module.exports = __webpack_public_path__ + "img/face51.c0d55d10.gif";